import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';

import { BusinessAndRole } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { find } from 'es-toolkit/compat';
import businessesAndRolesSelector from 'selectors/businessesAndRolesSelector';

export default createSelector(
  (state: StoreType) => oc(state.app).activeBusiness(),
  businessesAndRolesSelector,
  (activeBusiness, massagedBusinesses): BusinessAndRole | undefined => {
    return find(massagedBusinesses, (business) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return business.id === activeBusiness!.id;
    });
  }
);
